import { Link } from "react-router-dom";
import { Mail, ArrowRight, Shield } from "lucide-react";
import { Button } from "../components/ui/button";
import Logo from "../components/Logo";

const AffiliateVerify = () => {
  // Use Emergent Auth for Google OAuth (same as main app login)
  const handleGoogleSignIn = () => {
    // Store returnTo so after auth, user goes to affiliate DASHBOARD (not /affiliates)
    // Since they've already applied, signing in activates them → direct to dashboard
    sessionStorage.setItem('returnTo', '/affiliates/dashboard');
    // Redirect to Emergent Auth
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
          <Logo showText linkTo="/" />
        </div>
      </nav>

      <main className="pt-28 pb-16 px-6 md:px-12 flex items-center justify-center min-h-[80vh]">
        <div className="max-w-lg mx-auto text-center">
          {/* Icon */}
          <div className="w-20 h-20 rounded-full bg-[#D4F34A]/10 flex items-center justify-center mx-auto mb-8">
            <Mail className="w-10 h-10 text-[#D4F34A]" />
          </div>

          {/* Heading */}
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-4">
            One More Step
          </h1>

          {/* Main text */}
          <p className="text-text-muted text-lg mb-4">
            Your application is received!
          </p>
          <p className="text-text-muted mb-8">
            To activate your affiliate account and get your referral link, please sign in with Google to verify your email.
          </p>

          {/* Why verification */}
          <div className="bg-surface border border-[#262626] rounded-xl p-6 mb-8 text-left">
            <div className="flex items-center gap-2 mb-3">
              <Shield className="w-5 h-5 text-[#D4F34A]" />
              <h3 className="font-semibold text-white">Why verification?</h3>
            </div>
            <p className="text-sm text-text-muted">
              To protect our affiliate program from spam, we verify all affiliates via Google sign-in. 
              This ensures payouts go to real people with valid emails.
            </p>
          </div>

          {/* CTA - Sign in with Google via Emergent Auth */}
          <Button 
            onClick={handleGoogleSignIn}
            className="bg-[#D4F34A] text-black hover:bg-[#D4F34A]/90 font-bold px-6 w-full sm:w-auto"
            data-testid="google-signin-btn"
          >
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </Button>

          <p className="text-xs text-text-muted mt-4">
            After signing in, your affiliate account will be activated automatically.
          </p>

          {/* Back link */}
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-text-muted hover:text-white mt-6">
            <ArrowRight className="w-4 h-4 rotate-180" /> Back to Home
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-[#262626]">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-text-muted text-sm">
            Questions?{" "}
            <a href="mailto:hello@replydriven.com" className="text-[#D4F34A] hover:underline">
              hello@replydriven.com
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AffiliateVerify;
